import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PrintVehicleQrRoutingModule } from './print-vehicle-qr-routing.module';
import { PrintAssetVehicleLinkComponent } from './print-asset-vehicle-link/print-asset-vehicle-link.component';
import { PrintAssetVehicleLandingComponent } from './print-asset-vehicle-landing/print-asset-vehicle-landing.component';
import { PrintAssetVehicleDetailComponent } from './print-asset-vehicle-detail/print-asset-vehicle-detail.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCardModule } from '@angular/material/card';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';


@NgModule({
  declarations: [
    PrintAssetVehicleLinkComponent,
    PrintAssetVehicleLandingComponent,
    PrintAssetVehicleDetailComponent
  ],
  imports: [
    CommonModule,
    PrintVehicleQrRoutingModule,
    AcademicFormModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatCardModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule
  ]
})
export class PrintVehicleQrModule { }
